import api from '../token';

export const CountPedidos = async () => {
  try {
    const response = await api.post('/CountPedido');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    return [];
  }
};

